export const DEFAULT_TERMINOLOGY_SECTOR = 'default' as const;
export const TERMINOLOGY_ASSETS_BASE_PATH = 'assets/terminology' as const;

/**
 * Maps a normalized sector slug (or alias) to a JSON catalog name
 * under `assets/terminology/{catalog}.json`.
 *
 * Add an entry when a business-unit name should reuse an existing file
 * instead of requiring an exact filename match.
 */
export const SECTOR_TERMINOLOGY_ALIASES: Readonly<Record<string, string>> = {
  default: DEFAULT_TERMINOLOGY_SECTOR,
  salud: 'salud',
  health: 'salud',
  medicina: 'salud',
  medico: 'salud',
  clinica: 'salud',
  educacion: 'educacion',
  education: 'educacion',
  academia: 'educacion',
  corporativo: 'corporativo',
  empresarial: 'corporativo',
  empresa: 'corporativo',
};
